import styled from 'styled-components';

export const Container = styled.li`
  height: 5.2rem;
  background: #fff;
  border-radius: 0.4rem;

  padding-right: 1.5rem;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Options = styled.div`
  position: relative;
  cursor: pointer;

  &:hover {
    > div {
      opacity: 1;
      pointer-events: visible;
      width: 11rem;
    }
  }
  > svg {
    &:hover {
      background: #dadada;
      border-radius: 50%;
    }
  }

  > div {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 0;
    position: absolute;
    top: 2rem;
    left: -9.7rem;
    overflow: hidden;

    background: #ffffff;

    box-shadow: 0px 0px 4px #40404030;
    border-radius: 2px;

    opacity: 0;

    transition: 300ms ease-in-out;

    .divider {
      height: 1px;
      background: #cbcbcb;
      margin: 0 0.3rem;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;

      background: #ffffff;
      height: 4rem;
      border-radius: 0;

      color: #0f0f0f;
      font-size: 1.4rem;
      font-family: ${({ theme }) => theme.fontFamily.Nunito};
      font-weight: 600;
      line-height: 1.9rem;

      :last-child {
        color: #d90606;
      }

      &:hover {
        background: #40404030;
      }
    }
  }
`;

export const CardContainer = styled.div`
  cursor: pointer;
  width: 100%;
  height: 100%;
  padding: 1.5rem 2.6rem;
`;

export const CardLine = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
  margin-bottom: 1rem;

  span {
    display: flex;
  }
`;

export const CardLineLabel = styled.p`
  font-weight: 600;
`;

export const CardLineValue = styled.span`
  padding-left: 0.5rem;
  font-weight: 500;
`;

export const DeleteModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 3rem;
    text-transform: uppercase;
  }

  p {
    width: 80%;
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 6rem;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    button {
      width: 10rem;
      height: 4rem;
      background: transparent linear-gradient(96deg, #000000 0%, #232323 100%)
        0% 0% no-repeat padding-box;
      border-radius: 50px;
      opacity: 1;

      color: #fff;
      font-weight: bold;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`;
